import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { fetchTopTransfers, type TopTransfersData, type TopTransfersResponse } from '@/lib/network';

export const getTopTransfersQueryKey = (tournamentCalendarId: string | undefined) =>
  ['stats-centre', 'top-transfers', tournamentCalendarId ?? ''] as const;

type UseTopTransfersOptions = Omit<
  UseQueryOptions<TopTransfersResponse, Error, TopTransfersData>,
  'queryKey' | 'queryFn' | 'select'
>;

export const useTopTransfers = (
  tournamentCalendarId: string | undefined,
  options?: UseTopTransfersOptions
) =>
  useQuery<TopTransfersResponse, Error, TopTransfersData>({
    queryKey: getTopTransfersQueryKey(tournamentCalendarId),
    queryFn: () => {
      if (!tournamentCalendarId) {
        throw new Error('tournamentCalendarId is required to fetch top transfers');
      }
      return fetchTopTransfers(tournamentCalendarId);
    },
    select: response => response.data,
    enabled: !!tournamentCalendarId,
    staleTime: 60 * 1000,
    gcTime: 5 * 60 * 1000,
    ...options,
  });
